import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminLeadDetail = lazy(() => import("@/pages/admin/AdminLeadDetail"));

export const Route = createFileRoute("/admin/lead/$leadId")({
  component: () => <AdminLeadDetail />,
});
